import { render } from "./recipe-popup.vue?vue&type=template&id=54f41df2&scoped=true"
import script from "./recipe-popup.vue?vue&type=script&lang=js"
export * from "./recipe-popup.vue?vue&type=script&lang=js"

import "./recipe-popup.vue?vue&type=style&index=0&id=54f41df2&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f41df2"]])

export default __exports__